"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStoresUrlSlugAnalyticsDataGet200ResponseToJSON = exports.ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSONTyped = exports.ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSON = exports.instanceOfApiStoresUrlSlugAnalyticsDataGet200Response = void 0;
var runtime_1 = require("../runtime");
var AnalyticsSales_1 = require("./AnalyticsSales");
var AnalyticsTotals_1 = require("./AnalyticsTotals");
var AnalyticsTraffic_1 = require("./AnalyticsTraffic");
/**
 * Check if a given object implements the ApiStoresUrlSlugAnalyticsDataGet200Response interface.
 */
function instanceOfApiStoresUrlSlugAnalyticsDataGet200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiStoresUrlSlugAnalyticsDataGet200Response = instanceOfApiStoresUrlSlugAnalyticsDataGet200Response;
function ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSON(json) {
    return ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSONTyped(json, false);
}
exports.ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSON = ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSON;
function ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'totals': !(0, runtime_1.exists)(json, 'totals') ? undefined : (0, AnalyticsTotals_1.AnalyticsTotalsFromJSON)(json['totals']),
        'previousTotals': !(0, runtime_1.exists)(json, 'previousTotals') ? undefined : (0, AnalyticsTotals_1.AnalyticsTotalsFromJSON)(json['previousTotals']),
        'sales': !(0, runtime_1.exists)(json, 'sales') ? undefined : (json['sales'].map(AnalyticsSales_1.AnalyticsSalesFromJSON)),
        'traffic': !(0, runtime_1.exists)(json, 'traffic') ? undefined : (json['traffic'].map(AnalyticsTraffic_1.AnalyticsTrafficFromJSON)),
    };
}
exports.ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSONTyped = ApiStoresUrlSlugAnalyticsDataGet200ResponseFromJSONTyped;
function ApiStoresUrlSlugAnalyticsDataGet200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'totals': (0, AnalyticsTotals_1.AnalyticsTotalsToJSON)(value.totals),
        'previousTotals': (0, AnalyticsTotals_1.AnalyticsTotalsToJSON)(value.previousTotals),
        'sales': value.sales === undefined ? undefined : (value.sales.map(AnalyticsSales_1.AnalyticsSalesToJSON)),
        'traffic': value.traffic === undefined ? undefined : (value.traffic.map(AnalyticsTraffic_1.AnalyticsTrafficToJSON)),
    };
}
exports.ApiStoresUrlSlugAnalyticsDataGet200ResponseToJSON = ApiStoresUrlSlugAnalyticsDataGet200ResponseToJSON;
